import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import infoIcon from "../../assets/icons/infoIcon.svg";
import { logout } from "../../redux/slices/authSlice";
import Swal from "sweetalert2";

import closeIcon from "../../assets/icons/closeIcon.svg";
import { NotificationGlyph, ProfileGlyph } from "../common/icons";
import {
  HeaderComponents,
  HeaderContainer,
  HeaderIcons,
  HeaderTitle,
  NavigationContainer,
  MenuHeader,
  // Searchbar,
} from "./Headerstyle";

import {
  getNotification,
  getNotificationCount,
  deleteAllNotifications,
} from "../../redux/slices/notificationSlice";

// const notifications = [
//   { id: 1, title: "Advertiser Account not registered", message: "Your account is not registered." },
//   { id: 2, title: "New message from support", message: "You have a new message from support." },
//   { id: 3, title: "Profile Update", message: "Your profile has been updated successfully." },
// ];

const MenuGlyph = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <line x1="2" y1="4.5" x2="16" y2="4.5" />
      <line x1="2" y1="9" x2="16" y2="9" />
      <line x1="2" y1="13.5" x2="11" y2="13.5" />
    </g>
  </svg>
);

const Header = ({ title, onToggleSidebar, collapsed }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //const [notificationCount, setNotificationCount] = useState(25);
  const { notifications, count } = useSelector((state) => state.notification);
  const { user } = useSelector((state) => state.user);
  const userRole = localStorage.getItem('userRole');
  //console.log(count.count)

  useEffect(() => {
    dispatch(getNotificationCount());
    // const notificationsCount = notifications.filter((notify) => notify.isRead === false).length;
    // setNotificationCount(notificationsCount);
  }, [dispatch]);

  const handleNotification = () => {
    dispatch(getNotification());
  };
  const handleDeleteNotification = () => {
    dispatch(deleteAllNotifications());
    handleNotification();
    dispatch(getNotificationCount());
  };

  const [showMenu, setShowMenu] = useState(false);

  const openNav = () => {
    setShowMenu(true);
    handleNotification();
  };

  const closeNav = () => {
    setShowMenu(false);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: null,
      iconHtml: `<img src=${infoIcon} alt="error" style="width:50px;">`,
      showCancelButton: true,
      confirmButtonColor: "#3730a3",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
        navigate("/login");
      }
    });
  };
  return (
    <HeaderContainer>
      <HeaderTitle>
        <button
          type="button"
          className="toggle"
          onClick={onToggleSidebar}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <MenuGlyph />
        </button>
        <div className="crumb">
          <h2>{title}</h2>
          <span>ClickCircle admin</span>
        </div>
      </HeaderTitle>

      <HeaderComponents>
        <HeaderIcons>
          {userRole === 'SUPPORT' ? '' : (
          <button
            type="button"
            className="icon-button"
            onClick={showMenu ? closeNav : openNav}
            aria-label="Notifications"
          >
            <NotificationGlyph />
            {count?.count > 0 && (
              <span className="notification-badge">{count?.count}</span>
            )}
          </button>
          )}
          {showMenu && (
            <NavigationContainer className="menu">
              <MenuHeader>
                <h3>Notifications</h3>
                <span className="close-menu" onClick={closeNav}>
                  <img src={closeIcon} alt="Logo" />
                </span>
              </MenuHeader>
              <div className="clear">
                <p>{/* All Notifications ({notifications?.length}) */}</p>
                {notifications.length > 0 && (
                  <span onClick={handleDeleteNotification}>Clear all</span>
                )}
              </div>
              {notifications?.length > 0 ? (
                notifications.map((notification) => (
                  <div className="wrapper" key={notification.id}>
                    <h4>{notification.title}</h4>
                    <p>{notification.content}</p>
                  </div>
                ))
              ) : (
                <p className="empty">No notifications are currently available.</p>
              )}
            </NavigationContainer>
          )}

          <div className="nav-item">
            <div className="dropBtn">
              <span className="circled">
                <ProfileGlyph />
              </span>
              <div className="who">
                <strong>{user?.data?.firstName || "Account"}</strong>
                <small>{(userRole || "admin").toLowerCase()}</small>
              </div>
              <svg
                className="caret"
                viewBox="0 0 12 8"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="m1 1.5 5 5 5-5"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="dropdown-content">
              {userRole === 'SUPPORT' ? '' : (<Link to="/profile">Profile</Link>)}
              <Link onClick={handleLogout}>Logout</Link>
            </div>
          </div>
        </HeaderIcons>
      </HeaderComponents>
    </HeaderContainer>
  );
};

export default Header;
